const component = "section-programming-ranges-cell";

export const sectionProgrammingRangesCell = {
  component,
};
